<template>
  <!-- starting div -->
  <div id="page-content" class="customer-create-page" style="margin-top:-10px;">
    <!-- section 1 :page title for customer update -->
    <GlobalHeader title="Price List" @redirectPage="redirectPage"></GlobalHeader>
    <!-- section 2 : error validation block  -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode && Object.keys(message).length != 0">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert
            class="alert-transparent alert-danger"
            :show="(error_show && this.errors.any())||!unit_valid||!vol_valid"
          >
            <button
              type="button"
              @click="error_show = !error_show;unit_valid=true;vol_valid=true"
              class="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div>
              <p
                class="fw-semi-bold"
                v-if="!unit_valid||!vol_valid"
              >Please enter price list rate for atleast one product</p>
            </div>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope == 'price-list-form'">
              <!-- price_list_item -->
              <p
                class="fw-semi-bold"
                v-if="
                  item.field == 'price_list_item' ||
                    item.field == 'volume_price'
                "
              >Please enter price list rate for atleast one product</p>
              <p class="fw-semi-bold" v-else>{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      class="mt-3 pt-1"
      @submit.prevent="onSubmit('price-list-form')"
      id="price_list_form"
      data-vv-scope="price-list-form"
      style="margin-left:3px;margin-right:3px;"
    >
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Name" label-for="label" label-class="required" class="mb-3">
            <b-input
              v-validate="'required|max:100'"
              v-model="field.pricing_name"
              name="Label Name"
              data-vv-name="label name"
            ></b-input>
          </b-form-group>
          <b-form-group label="Product Price" label-for="label" class="mb-3">
            <b-form-radio-group v-model="field.pricing_type">
              <b-form-radio
                @change="disable_price_scheme ? (field.rounding_type = 1) : ''"
                name="pricing type"
                value="fixed_percentage"
                @input="bulkupdate = false;unit_valid=true;vol_valid = true;checkboxes1 = [];percent_value = '';CheckedCount=0"
              >By percentage</b-form-radio>
              <b-form-radio
                @change="
                !field.pricing_scheme ? (field.pricing_scheme = 1) : '';
                getItems == 0 || !disable_price_scheme ? getProductList() : '';
              "
                name="pricing type"
                class="pt-1"
                value="per_item"
                 @input="bulkupdate = false;checkboxes1 = [];percent_value = '';CheckedCount=0"
              >By price for each products.</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <template v-if="field.pricing_type == 'fixed_percentage'">
            <b-form-group
              label="Percentage"
              label-for="required"
              label-class="required"
              class="mb-3"
            >
              <b-input-group>
                <template v-slot:append>
                  <b-dropdown
                    :text="field.is_increase_formatted"
                    variant="light"
                    style="border:1px solid #dadada !important;height:32px;"
                  >
                    <b-dropdown-item
                      @click="
                        (field.is_increase_formatted = 'Markup'),
                          (field.is_increase = 1)
                      "
                    >Markup</b-dropdown-item>
                    <b-dropdown-item
                      @click="
                        (field.is_increase_formatted = 'Markdown'),
                          (field.is_increase = 0)
                      "
                    >Markdown</b-dropdown-item>
                  </b-dropdown>
                </template>
                <b-form-input
                  v-validate="'required|max_value:10000000'"
                  @blur="roundOff('percentage', 6)"
                  data-vv-name="percentage"
                  :class="{
                    'form-control': true,
                    'text-right': true,
                    'is-invalid': field.percentage < 0 ? true : false,
                  }"
                  v-model.trim="field.percentage"
                  name="percentage"
                  type="text"
                  id="percentage"
                  style="border-left:0 !important;border-right:0 !important"
                ></b-form-input>

                <template v-slot:prepend>
                  <b-input-group-text>%</b-input-group-text>
                </template>
              </b-input-group>
            </b-form-group>
          </template>
          <template v-if="field.pricing_type == 'per_item'">
            <b-form-group label="Pricing scheme" label-for="Type" class="mb-3">
              <b-form-radio-group
                class="mt-1"
                id="pricing_scheme"
                v-model="field.pricing_scheme"
                :disabled="page == 'update' && disable_price_scheme"
                @input="
                  bulkupdate = false;
                  checkboxes1 = [];
                  percent_value = '';
                  CheckedCount = 0;
                "
                :options="[
                  { value: 1, text: 'Unit Pricing' },
                  { value: 2, text: 'Volume Pricing' },
                ]"
              >
                <span v-if="field.pricing_scheme == 2">
                  <b-dropdown
                    variant="white"
                    dropright
                    size="xs"
                    class="no-caret-dropdown"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template slot="button-content" class="px-0">
                      <i
                        class="la la-question-circle la-lg"
                        style="position: relative;bottom: 1px;left: -5px;color:#676666;"
                      ></i>
                    </template>
                    <b-dropdown-form class="p-3" style="width:500px;height:320px">
                      <p>
                        Use Volume Pricing to configure the unit price of the item
                        to be based on the quantity of items sold or purchased.
                      </p>
                      <p>
                        <span class="fw-semi-bold">For Example,</span> when less
                        than 10 items are sold or purchased, you can set each
                        item's price at Rs.10 and when more than 10 items are sold
                        or purchased, you can set each item's price at Rs.5. So,
                        for 5 items, the total price will be Rs.50, while for 15
                        items, the total price will be Rs.75.
                      </p>
                      <p>Note:</p>
                      <ul class="px-3" style="list-style-type: circle !important;">
                        <li>
                          If you don't enter the End Quantity for the last range
                          and the item quantity is greater than the start quantity
                          of the last range, then the custom rate of the last
                          range will be applied.
                        </li>
                        <li>
                          If you don't enter a custom range, then the default item
                          rate will be applied for that quantity range.
                        </li>
                      </ul>
                    </b-dropdown-form>
                  </b-dropdown>
                </span>
              </b-form-radio-group>
            </b-form-group>
          </template>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <template v-if="field.pricing_type == 'fixed_percentage'">
            <b-form-group label="Round Off To" label-for="required" class="mb-3">
              <b-input-group>
                <v-select
                  :clearable="false"
                  label="label"
                  index="value"
                  name="rounding type"
                  v-validate="'required'"
                  data-vv-name="Round Off To"
                  v-model.trim="field.rounding_type"
                  :options="details.rounding_type"
                  style="width:80%"
                ></v-select>
                <template v-slot:append>
                  <b-dropdown
                    variant="white"
                    dropdown
                    size="xs"
                    class="no-caret-dropdown"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template slot="button-content" class="px-0">
                      <i
                        class="la la-question-circle la-lg"
                        style="position: relative;bottom: 1px;left: -5px;color:#676666;"
                      ></i>
                    </template>
                    <b-dropdown-form class="p-3" style="width:475px;height:270px">
                      <h6>Rounding Examples</h6>
                      <table class="table table-bordered text-sm">
                        <thead>
                          <tr>
                            <th>ROUND OFF TO</th>
                            <th class="text-right">INPUT VALUE</th>
                            <th class="text-right">ROUNDED VALUE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-primary">Never mind</td>
                            <td class="text-right">1000.678</td>
                            <td class="text-right">1000.678</td>
                          </tr>
                          <tr>
                            <td class="text-primary">Nearest whole number</td>
                            <td class="text-right">1000.678</td>
                            <td class="text-right">1001</td>
                          </tr>
                          <tr>
                            <td class="text-primary">0.99</td>
                            <td class="text-right">1000.678</td>
                            <td class="text-right">1000.99</td>
                          </tr>
                          <tr>
                            <td class="text-primary">0.50</td>
                            <td class="text-right">1000.678</td>
                            <td class="text-right">1000.50</td>
                          </tr>
                          <tr>
                            <td class="text-primary">0.49</td>
                            <td class="text-right">1000.678</td>
                            <td class="text-right">1000.49</td>
                          </tr>
                        </tbody>
                      </table>
                    </b-dropdown-form>
                  </b-dropdown>
                </template>
              </b-input-group>
            </b-form-group>
          </template>
          <template v-if="field.pricing_type == 'per_item'">
            <b-form-group label="Currency" label-for="currency" class="mb-3">
              <v-select
                :clearable="false"
                :disabled="field.is_used > 0"
                id="search-select"
                v-model.trim="field.currency_id"
                name="currency"
                @change="getCurrencycode($event)"
                data-vv-name="currency"
                v-validate="{ required: field.pricing_type == 'per_item' }"
                size="sm"
                index="value"
                label="label"
                :options="details.currency_list"
              />
            </b-form-group>
          </template>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Description" label-for="description" class="mt-3">
            <b-form-textarea
              v-validate="'max:255'"
              v-model.trim="field.pricing_desc"
              name="pricing_desc"
              data-vv-name="pricing description"
              :rows="4"
              id="pricing_desc"
              placeholder="Descriptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template v-if="field.pricing_type == 'per_item'">
        <b-row style="max-width:1200px" class="my-3">
          <b-col>
            <h6 class="text-primary bg-light px-2 py-3 fw-bold cursor_pointer">
              Update Custom Price in Bulk
              <span
                class="float-right"
                style="position:relative;bottom:8px;"
              >
                <b-button
                  :pressed.sync="field.per_item_import"
                  @click="
                bulkupdate = false;
                checkboxes1 = [];
                percent_value = '';
                CheckedCount = 0;
              "
                  variant="light"
                  class="btn-sm"
                  v-if="details.pdt_count <= 1000"
                >Import price lists for products</b-button>
              </span>
            </h6>
          </b-col>
        </b-row>
        <b-row class="pb-5" style="max-width:1200px">
          <input
            type="hidden"
            class="form-control"
            name="volume_price"
            v-model="validprice"
            v-if="!field.per_item_import && field.pricing_scheme == 2"
            data-vv-name="volume_price"
          />
          <b-col
            class="col-lg-12"
            :class="{
            'col-lg-9': field.pricing_scheme == 1 ? true : false,
            'col-lg-11': field.pricing_scheme == 2 ? true : false,
          }"
          >
            <p
              class="text-sm mb-1"
              :class="{ 'pt-5': details.pdt_count > 1000 ? true : false }"
              style="word-break:break-all"
            >
              {{
              field.per_item_import == false
              ? field.pricing_scheme != 2 && bulkupdate
              ? "Select multiple products, enter a percentage and click Update Custom Rate in Bulk to add a custom rate for each product faster"
              : "Add custom price for each product to be saved as a price list"
              : "Export your items in an XLS file, add the custom rate for each product and import the same file in CSV or XLS format"
              }}.
              <span
                class="float-right text-link"
                style="cursor:pointer"
                v-if="!bulkupdate && !field.per_item_import"
                @click="bulkupdate = !bulkupdate"
              >
                <i class="la la-cog pr-1 la-lg"></i>Update Ranges in Bulk
              </span>

              <template v-if="field.pricing_scheme == 2 && bulkupdate">
                <span class="float-right" style="position:relative;bottom:8px;">
                  <b-button
                    size="sm"
                    variant="default"
                    class="btn-rounded mr-2"
                    :disabled="CheckedCount == 0"
                    @click="$root.$emit('bv::show::modal', 'generateslab')"
                  >Update Bulk Range</b-button>
                  <span
                    aria-hidden="true"
                    @click="
                  (bulkupdate = !bulkupdate),
                    (percent_value = ''),
                    checkAll({
                      target: {
                        checked: false,
                      },
                    }),
                    (CheckedCount = 0),
                    (checkboxes1[0] = false)
                "
                    style="font-size:18px;cursor:pointer"
                  >&times;</span>
                </span>
              </template>
            </p>

            <b-row v-if="field.pricing_scheme != 2 && bulkupdate" class="bg-light my-2 mx-0">
              <b-col class="py-2">
                <b-form-group label-cols="5" label-for="bulk-percent">
                  <template slot="label">
                    Percentage
                    <span
                      v-b-tooltip.right="
                          'Enter a percentage by which you want to mark up or mark down the product price. Use (-) symbol for making down the price.'
                        "
                    >
                      <i class="la la-info-circle la-lg"></i>
                    </span>
                  </template>
                  <b-form-input
                    v-model="percent_value"
                    :class="{ 'is-invalid': percent_value < -100 }"
                    placeholder="Enter a percentage"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="py-2">
                <span class="float-right">
                  <b-button
                    size="sm"
                    variant="default"
                    class="btn-rounded mr-2"
                    :disabled="
                        CheckedCount == 0 ||
                          percent_value === '' ||
                          percent_value < -100
                      "
                    @click="updatePercentage()"
                  >Update Custom Rate in Bulk</b-button>
                  <span
                    aria-hidden="true"
                    @click="
                        (bulkupdate = !bulkupdate),
                          (percent_value = ''),
                          checkAll({
                            target: {
                              checked: false,
                            },
                          }),
                          (CheckedCount = 0),
                          (checkboxes1[0] = false)
                      "
                    style="font-size:18px;cursor:pointer"
                  >&times;</span>
                </span>
              </b-col>
            </b-row>
            <div>
              <template>
                <div class="table-responsive" v-if="!field.per_item_import">
                  <table class="table table-bordered reports-table-border pricing-table-head">
                    <thead>
                      <th class="text-center align-middle" style="width:45px" v-if="bulkupdate">
                        <div class="abc-checkbox index-checkbox text-center">
                          <input
                            type="checkbox"
                            id="checkboxall"
                            v-model="checkboxes1[0]"
                            @change="checkAll($event)"
                          />
                          <label for="checkboxall" style="position:relative;left: 12px;" />
                        </div>
                      </th>
                      <th class="text-left" style="min-width:250px">
                        <span v-if="!searchinput">
                          Product Details
                          <i
                            class="la la-search"
                            style="cursor:pointer"
                            @click="searchinput = !searchinput"
                          ></i>
                        </span>
                        <b-form-group v-if="searchinput" style="position:relative;">
                          <input
                            type="text"
                            class="form-control"
                            v-model="searchitems"
                            style="height: 33px;position: absolute;top: -12px;"
                          />
                          <span
                            @click="
                            (searchitems = ''), (searchinput = !searchinput)
                          "
                            class="close"
                            style="padding-top:5px;padding-right:10px;cursor:pointer;position: absolute;text-align: right;font-size: 18px !important;right: 3px;top: -10px;"
                          >&times;</span>
                        </b-form-group>
                      </th>
                      <th class="text-right" style="width:160px">Standard Price({{ orgCurrency }})</th>
                      <th class="text-right" style="width:200px" v-if="field.pricing_scheme == 1">
                        Custom Price({{ field.currency_code }})
                        <span
                          v-b-tooltip.top="'Max value: 100000000000000'"
                        >
                          <i class="la la-info-circle la-lg"></i>
                        </span>
                      </th>
                      <template v-if="field.pricing_scheme == 2">
                        <th
                          class="text-right pr-4"
                          style="border-right:none;width:150px "
                        >Start Quantity</th>
                        <th
                          class="text-right pr-4"
                          style="border-right:none;border-left:none;width:150px"
                        >End Quantity</th>
                        <th class="text-right pr-4" style="border-left:none;width:150px">
                          Custom Rate({{ field.currency_code }})
                          <span
                            v-b-tooltip.top="'Max value: 100000000000000'"
                          >
                            <i class="la la-info-circle la-lg"></i>
                          </span>
                        </th>
                      </template>
                    </thead>
                    <tbody class="pricing-table">
                      <tr v-if="items.length == 0">
                        <td
                          :colspan="field.pricing_scheme == 1 ? 3 : 5"
                          class="text-center align-middle"
                        >No products are present</td>
                      </tr>
                      <template v-else>
                        <tr
                          v-if="
                          item.pdt_type == 3 ||
                            (item.pdt_type == 2 && field.is_sales == 0) ||
                            (field.is_sales == 1 && item.pdt_type == 1)
                        "
                          v-for="(item, index) in filtereditemList"
                          :key="item.id"
                        >
                          <div v-if="!item.done">
                            {{
                            ((item.done = 1),
                            (item.index = index),
                            (item.slab =
                            typeof item.slab === "string" && item.slab != ""
                            ? JSON.parse(item.slab)
                            : []))
                            }}
                          </div>
                          <td class="text-center align-middle" v-if="bulkupdate">
                            <div class="abc-checkbox index-checkbox text-center">
                              <input
                                type="checkbox"
                                v-model="checkboxes1[index + 1]"
                                :id="'checkbox' + (index + 1)"
                                :true-value="index"
                                :value="item.index"
                                @change="
                                (event) =>
                                  changeCheck(event, 'checkboxes1', index + 1)
                              "
                              />
                              <label :for="'checkbox' + (index + 1)" />
                            </div>
                          </td>
                          <td style="width:250px !important" class="align-middle">
                            <span class="text">{{ item.pdt_name }}</span>
                            <br />
                            <small class="text-muted word-break">SKU : {{ item.pdt_sku }}</small>
                          </td>
                          <td class="text-right align-middle">
                            {{ orgCurrencySymbol + " "
                            }}{{
                            field.is_sales == 1
                            ? item.pdt_sal_price
                            : item.pdt_pur_price
                            }}
                          </td>
                          <td v-if="field.pricing_scheme == 1" class="align-middle">
                            <input
                              type="text"
                              :class="{
                              'is-invalid':
                                item.pricing_rate < 0 ? true : false,
                            }"
                              class="form-control text-right"
                              @blur="
                              CheckNan(
                                item.pricing_rate,
                                'pricing_rate',
                                item.index
                              )
                            "
                              v-bind:value="item.pricing_rate"
                              v-on:input="item.pricing_rate = $event.target.value"
                            />
                          </td>
                          <template v-if="field.pricing_scheme == 2">
                            <td colspan="3" class="align-middle">
                              <div
                                class="pb-2"
                                v-for="(itemslab, slabindex) in item.slab"
                                :key="itemslab.key"
                                @mouseover="
                                showByIndex = item.index + ' ' + slabindex
                              "
                                @mouseout="showByIndex = null"
                              >
                                <b-row class="m-0">
                                  <b-col cols="4" class="pl-0">
                                    <input
                                      type="text"
                                      @blur="
                                      slabvalidation(
                                        itemslab.start_qty,
                                        item.index,
                                        slabindex,
                                        'start_qty'
                                      )
                                    "
                                      :class="{
                                      'is-invalid':
                                        itemslab.start_qty < 0 ? true : false,
                                    }"
                                      class="form-control text-right"
                                      v-bind:value="itemslab.start_qty"
                                      v-on:input="
                                      itemslab.start_qty = $event.target.value
                                      
                                    "
                                    />
                                  </b-col>
                                  <b-col cols="4" class="pl-0">
                                    <input
                                      :class="{
                                      'is-invalid':
                                        itemslab.end_qty < 0 ? true : false,
                                    }"
                                      type="text"
                                      @blur="
                                      slabvalidation(
                                        itemslab.end_qty,
                                        item.index,
                                        slabindex,
                                        'end_qty'
                                      )
                                    "
                                      class="form-control text-right"
                                      v-bind:value="itemslab.end_qty"
                                      v-on:input="
                                      itemslab.end_qty = $event.target.value
                                    "
                                    />
                                  </b-col>
                                  <b-col cols="4" class="slab-cols pl-0">
                                    <input
                                      type="text"
                                      :class="{
                                      'is-invalid':
                                        itemslab.custom_price < 0
                                          ? true
                                          : false,
                                    }"
                                      class="form-control text-right"
                                      @blur="
                                      slabvalidation(
                                        itemslab.custom_price,
                                        item.index,
                                        slabindex,
                                        'custom_price'
                                      )
                                    "
                                      v-bind:value="itemslab.custom_price"
                                      v-on:input="
                                      itemslab.custom_price =
                                        $event.target.value
                                    "
                                    />
                                    <i
                                      class="glyphicon glyphicon-trash slab-trash"
                                      @click="item.slab.splice(slabindex, 1)"
                                      v-if="
                                      showByIndex ===
                                        item.index + ' ' + slabindex
                                    "
                                    ></i>
                                  </b-col>
                                </b-row>
                              </div>
                              <b-alert
                                class="alert-transparent alert-danger"
                                :show="true"
                                v-if="
                                Array.isArray(item.error) &&
                                  item.error.length > 0
                              "
                              >
                                <p
                                  v-for="error in item.error"
                                  :key="error.id"
                                  class="fw-semi-bold"
                                >{{ error }}</p>
                              </b-alert>
                              <span
                                class="text-link"
                                style="cursor:pointer"
                                v-if="
                                item.slab == '' ||
                                  (Array.isArray(item.slab) &&
                                    item.slab.length < 10)
                              "
                                @click="addNewRow(item.index)"
                              >Add new row</span>
                            </td>
                          </template>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <p class="mt-3" v-if="field.per_item_import">
                  <downloadexcel
                    class="mb-3 text-link"
                    :fetch="fetchExportData"
                    :exportDatas="
                    field.pricing_scheme == 1
                      ? export_xl
                      : export_pricing_scheme
                  "
                    type="csv"
                    :name="'Products.csv'"
                    style="cursor:pointer"
                    ref="exportData"
                  >
                    <span class="la la-upload mr-1"></span>Export Custom Prices
                  </downloadexcel>
                  <upload-excel-component
                    :on-success="handleSelectedFile"
                    :before-upload="beforeUpload"
                  />
                  <b-form-group
                    label=" File Name "
                    label-cols="2"
                    label-class="required"
                    label-for="file name"
                  >
                    <label class="col-form-label">{{ file_name }}</label>
                  </b-form-group>
                </p>
                <input
                  type="hidden"
                  class="form-control"
                  v-if="!field.per_item_import && field.pricing_scheme == 1"
                  name="price_list_item"
                  :value="priceatleastoneitem.length"
                  data-vv-name="price_list_item"
                  v-validate="'min_value:1'"
                />
              </template>
            </div>
          </b-col>
        </b-row>
      </template>
      <div class="footer" style="box-shadow:0 -4px 5px -3px #ccc;">
        <div class="form-action" style="background:none !important;">
          <b-button
            type="submit"
            size="sm"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="
              (per_item_file_uploaded == false &&
                field.pricing_type == 'per_item' &&
                field.per_item_import == true) ||
                submitted
            "
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ page == "create" ? "Save" : "Update" }}
          </b-button>
        </div>
      </div>
    </b-form>
    <SlabModal v-on:bulkupdatevolulme="bulkupdatevolulme"></SlabModal>
  </div>
</template>
<script>
import vSelect from "vue-select"; // vue seatch select component
import { mapState, mapGetters } from "vuex"; // to accss state from all the vuex file
import getPageTitle from "@/utils/get-page-title"; // to set page title
import downloadexcel from "@/components/DownloadExcel/DownloadExcel"; // to excel export the output
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import $ from "jquery";
import SlabModal from "@/components/Form/PriceList/SlabModal"; // customer modal
export default {
  props: ["page", "submitted", "duplicatecode"],
  name: "Pricelist",
  components: {
    vSelect,
    SlabModal,
    getPageTitle,
    downloadexcel,
    UploadExcelComponent
  },
  data() {
    return {
      percent_value: "",
      showByIndex: "",
      bulkupdate: false,
      searchinput: false,
      per_item_file_uploaded: false,
      FormUpdate: 0,
      error_show: false,
      field: this.createFreshEventObject(),
      items: [],
      getItems: 0,
      priceatleastoneitem: [],
      validprice: 0,
      searchitems: "",
      checkboxes1: [],
      CheckedCount: 0,
      check_index: [],
      export_xl: {
        "Product Name": "pdt_name",
        "Product SKU": "pdt_sku",
        "Product Price": "pdt_sal_price",
        "Price List Rate": "pricing_rate"
      },
      export_pricing_scheme: {
        "Product Name": "pdt_name",
        "Product SKU": "pdt_sku",
        "Product Price": "pdt_sal_price",
        "Start Quantity": "start_qty",
        "End Quantity": "end_qty",
        "Custom Price": "custom_price"
      },
      per_item_excel_contents: [],
      file_name: "",
      disable_price_scheme: false,
      unit_valid: true,
      vol_valid: true
    };
  },
  methods: {
    redirectPage(){
      if (this.$store.state.pricinglist.pricelist_index_history) {
          this.$router.push(this.$store.state.pricinglist.pricelist_index_history);
        }else{
      this.$router.push({name:'PriceList'})}

    },
    updatePercentage() {
      var price = 0,
        rate = 0;
      for (var i = 0; i < this.filtereditemList.length; i++) {
        if (this.checkboxes1[i + 1] === i || this.checkboxes1[i + 1] === true) {
          this.filtereditemList[i].pricing_rate = 0;
          price = parseFloat(
            this.field.is_sales == 1
              ? this.filtereditemList[i].pdt_sal_price
              : this.filtereditemList[i].pdt_pur_price
          ).toFixed(6);
          rate = parseFloat(price * (this.percent_value / 100)).toFixed(6);
          this.filtereditemList[i].pricing_rate = parseFloat(
            parseFloat(parseFloat(price) + parseFloat(rate)).toFixed(6)
          );
          this.CheckNan(
            this.filtereditemList[i].pricing_rate,
            "pricing_rate",
            i
          );
        }
      }
      this.bulkupdate = false;
      this.checkboxes1 = [];
      this.percent_value = "";
      this.CheckedCount = 0;
    },

    //select the checkbox//
    changeCheck(ev, checkbox, id) {
      var pdt_ids = this.checkboxes1;
      pdt_ids = pdt_ids.filter(item => item !== false);
      // check all if page length matches
      if (pdt_ids.length == this.items.length) {
        this[checkbox][0] = true;
      }
      // uncheck if any of the checkbox is unchecked
      if (!ev.target.checked) {
        this[checkbox][0] = false;
      }

      if (this[checkbox][id] !== false || this[checkbox][id] === 0) {
        this.CheckedCount = parseInt(this.CheckedCount) + 1;
      } else {
        this.CheckedCount = parseInt(this.CheckedCount) - 1;
      }
    },
    checkAll(ev) {
      this.check_index = [];

      this.items.map((value, index) => {
        this.checkboxes1[index + 1] =
          ev.target.checked == true ? value.index : false;
      });

      this.CheckedCount = ev.target.checked == true ? this.items.length : 0;
    },
    addNewRow(index) {
      if (!Array.isArray(this.items[index].slab)) {
        this.items[index].slab = [];
        this.items[index].slab.push({
          start_qty: "",
          end_qty: null,
          custom_price: ""
        });
      } else {
        var getlast = parseInt(this.items[index].slab.length) - 1;
        this.items[index].slab.push({
          start_qty:
            this.items[index].slab[getlast] &&
            this.items[index].slab[getlast].end_qty
              ? parseFloat(this.items[index].slab[getlast].end_qty) + 1
              : "",
          end_qty: null,
          custom_price: ""
        });
      }
    },
    beforeUpload(file) {
      if (!file) {
        // this.displayNotification("Please choose file to upload", "error");
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      }
      return false;
    },
    handleSelectedFile(convertedData) {
      this.file_name = convertedData.file_name;
      if (this.field.pricing_type == "per_item") {
        this.per_item_excel_contents = convertedData;
        this.per_item_file_uploaded = true;
      }
    },
    async fetchExportData() {
      this.export_xl = await {
        "Product Name": "pdt_name",
        "Product SKU": "pdt_sku",
        "Product Price":
          this.field.is_sales == 1 ? "pdt_sal_price" : "pdt_pur_price",
        "Price List Rate": "pricing_rate"
      };
      this.export_pricing_scheme = await {
        "Product Name": "pdt_name",
        "Product SKU": "pdt_sku",
        "Product Price":
          this.field.is_sales == 1 ? "pdt_sal_price" : "pdt_pur_price",
        "Start Quantity": "start_qty",
        "End Quantity": "end_qty",
        "Custom Price": "custom_price"
      };
      if (this.field.pricing_scheme == 2) {
        var export_xls = [];
        for (var index = 0; index < this.items.length; index++) {
          if (this.items[index].slab.length > 0) {
            for (
              var slabindex = 0;
              slabindex < this.items[index].slab.length;
              slabindex++
            ) {
              export_xls.push({
                pdt_name: this.items[index].pdt_name,
                pdt_sku: this.items[index].pdt_sku,
                pdt_sal_price: this.items[index].pdt_sal_price,
                pdt_pur_price: this.items[index].pdt_pur_price,
                start_qty: this.items[index].slab[slabindex].start_qty,
                end_qty: this.items[index].slab[slabindex].end_qty,
                custom_price: this.items[index].slab[slabindex].custom_price
              });
            }
          } else {
            export_xls.push({
              pdt_name: this.items[index].pdt_name,
              pdt_sku: this.items[index].pdt_sku,
              pdt_sal_price: this.items[index].pdt_sal_price,
              pdt_pur_price: this.items[index].pdt_pur_price,
              start_qty: "",
              end_qty: null,
              custom_price: ""
            });
          }
        }
        return export_xls;
      } else {
        return this.items;
      }
    },
    CheckNan(amount, field, index) {
      amount =
        isNaN(amount) ||
        amount == null ||
        (amount == "" && amount !== 0) ||
        typeof amount == "undefined" ||
        amount < 0 ||
        amount > 100000000000000
          ? null
          : parseFloat(amount);
      this.items[index][field] = amount;
      var key = $.inArray(index, this.priceatleastoneitem);
      if (amount != null && !this.priceatleastoneitem.includes(index)) {
        this.priceatleastoneitem.push(index);
      } else if (amount == null && key != -1) {
        this.priceatleastoneitem.splice(key, 1);
      }
    },
    slabvalidation(value, index, slabindex, field) {
      value =
        isNaN(value) ||
        value == null ||
        (value == "" && value !== 0) ||
        typeof value == "undefined" ||
        value < 0 ||
        value > 100000000000000
          ? null
          : parseFloat(value);
      this.items[index].slab[slabindex][field] = value;
    },
    getProductList() {
      this.field.currency_id = this.field.currency_id
        ? this.field.currency_id
        : this.org_details.org_currency;
      this.getItems = 1;
      this.$store
        .dispatch("pricinglist/getProductlist", {
          id: this.$route.params.id || ""
        })
        .then(result => {
          this.items = result.data.items;
          if (this.field.pricing_scheme == 1) {
            this.priceatleastoneitem = result.data.priceatleastoneitem;
          }
        });
    },
    updateFields() {
      this.field = this.list.field;
      this.disable_price_scheme = this.field.pricing_scheme ? true : false;
      this.$set(
        this.field,
        "per_item_import",
        this.details.pdt_count > 1000 ? true : false
      );
      if (this.field.pricing_type == "per_item") {
        this.getProductList();
      }
    },
    //  for rounding off total maount modal
    roundOff(field, digits) {
      var digit = parseInt(digits);
      if (!(this.field[field] === "")) {
        this.field[field] =
          typeof this.field[field] != undefined && !isNaN(this.field[field])
            ? parseFloat(parseFloat(this.field[field]).toFixed(digit))
            : parseFloat(parseFloat(0).toFixed(digit));
        if (this.field[field] < 0 && field == "percentage") {
          this.field[field] = "";
        }
      }
    },

    getCurrencycode(val) {
      this.field.currency_code = this.getDetails(
        this.$AppDetails.currency_details,
        val,
        "currency_code"
      );
    },
    createFreshEventObject() {
      return {
        is_increase_formatted: "Markup",
        is_increase: 1,
        pricing_type: "fixed_percentage",
        pricing_name: "",
        pricing_scheme: 1,
        is_sales: 1,
        pricing_desc: "",
        per_item_import: false,
        currency_id: "",
        currency_code: "",
        percentage: "",
        rounding_type: 1
      };
    },
    bulkupdatevolulme(ev) {
      for (var i = 0; i < this.checkboxes1.length; i++) {
        var item = this.items[this.checkboxes1[i]];
        if (item) {
          if (
            (item.pdt_name &&
              item.pdt_name
                .toLowerCase()
                .includes(this.searchitems.toLowerCase())) ||
            (item.pdt_sku &&
              item.pdt_sku
                .toLowerCase()
                .includes(this.searchitems.toLowerCase()))
          ) {
            var price =
              this.field.is_sales == 1
                ? item.pdt_sal_price
                : item.pdt_pur_price;
            $.each(ev, (index, value) => {
              var percentage = value.custom_percent;
              if (value.custom_percent < 0) {
                percentage = Math.abs(value.custom_percent);
              }
              var custom_price =
                (parseFloat(price) * parseFloat(percentage)) / 100;

              if (value.custom_percent < 0) {
                custom_price = parseFloat(price) - parseFloat(custom_price);
              } else {
                custom_price = parseFloat(price) + parseFloat(custom_price);
              }
              value.custom_price = parseFloat(
                parseFloat(custom_price).toFixed(6)
              );
              if (value.custom_price > 100000000000000) {
                value.custom_price = "";
              }
            });
            item.slab = JSON.parse(JSON.stringify(ev));
          }
        }
      }
      this.bulkupdate = !this.bulkupdate;
      this.checkAll({
        target: {
          checked: false
        }
      });
      this.CheckedCount = 0;
      this.checkboxes1[0] = false;
    },
    async submitValidate() {
      this.validprice = await 0;
      var error_occur = await 0;
      if (this.field.pricing_scheme == 2 && !this.field.per_item_import) {
        for (var index = 0; index < this.items.length; index++) {
          var slab = this.items[index].slab;
          var start_qty_valid = 0;
          var end_qty_valid = 0;
          var custom_price_valid = 0;
          var error = [];
          var validslab = [];
          var decimal_end = 0;
          var decimal_start = 0;
          for (var i = 0; i < slab.length; i++) {
            if (
              slab[i].start_qty != "" ||
              slab[i].end_qty != "" ||
              slab[i].custom_price != ""
            ) {
              var value =
                isNaN(slab[i].custom_price) ||
                slab[i].custom_price == null ||
                (slab[i].custom_price == "" && slab[i].custom_price !== 0) ||
                typeof slab[i].custom_price == "undefined" ||
                slab[i].custom_price < 0
                  ? null
                  : parseFloat(value);

              if (
                i != 0 &&
                slab[i].start_qty != parseInt(slab[i - 1].end_qty) + 1
              ) {
                start_qty_valid = 1;
              }
              if (slab[i].start_qty >= slab[i].end_qty) {
                end_qty_valid = 1;
              }
              if (slab[i].start_qty % 1 != 0) {
                decimal_start = 1;
              }
              if (slab[i].end_qty % 1 != 0) {
                decimal_end = 1;
              }
              if (value == null) {
                custom_price_valid = 1;
              }
              validslab.push(slab[i]);
            }
          }
          if (validslab.length > 0) {
            this.validprice = 1;
            this.items[index].slab = validslab;
          } else {
            this.items[index].slab = [];
          }
          if (
            this.items[index].slab.length == 1 &&
            this.items[index].slab[0].end_qty == null
          ) {
            end_qty_valid = 0;
          }

          if (start_qty_valid == 1) {
            error.push(
              "Ensure that there are no gaps between the start quantity and the previous end quantity."
            );
          }
          if (end_qty_valid == 1) {
            error.push(
              "Please make sure end quantity greater than start quantity"
            );
          }
          if (custom_price_valid == 1) {
            error.push("Enter a valid custom price");
          }
          if (decimal_start == 1) {
            error.push("Invalid value passed for start quantity");
          }
          if (decimal_end == 1) {
            error.push("Invalid value passed for end quantity");
          }

          this.items[index].error = error;
          if (error.length > 0) {
            error_occur = 1;
          }
        }

        if (!this.field.per_item_import && this.field.pricing_scheme == 2) {
          this.vol_valid = await (error_occur > 0 || this.validprice == 0
            ? false
            : true);
        }
 this.unit_valid = await true;
        return error_occur;
      }
       // Validation for unit pricing
      if(this.field.pricing_scheme == 1 && this.field.pricing_type == 'per_item'){
        var validunit = [];
        for(var i=0;i<this.filtereditemList.length;i++){
           
         isNaN(this.filtereditemList[i].pricing_rate) ||
                this.filtereditemList[i].pricing_rate == null ||
                (this.filtereditemList[i].pricing_rate == "" && this.filtereditemList[i].pricing_rate !== 0) ||
                typeof this.filtereditemList[i].pricing_rate == "undefined" ||
                this.filtereditemList[i].pricing_rate < 0
                  ? validunit.push('0')
                  : validunit.push(this.filtereditemList[i].pricing_rate)
        }
        var isValidUnit = (currentValue) => currentValue == '0';
   if(validunit.length >0){
     this.unit_valid =  validunit.every(isValidUnit)?false:true}
   this.vol_valid = await true;
       }
    },
    async onSubmit(scope) {
      var restrictsubmit = await (this.submitValidate() > 0 ? 1 : 0);

      this.$validator.validateAll(scope).then(result => {
        if (
          result &&
          restrictsubmit == 0 &&
          this.unit_valid &&
          this.vol_valid
        ) {
          //  send the json data
          // this.errors.items = this.this.message;

          let data = JSON.stringify({
            id: this.$route.params.id,
            field: this.field,
            items: this.items,
            per_item_excel_contents: this.per_item_excel_contents
          });

          this.$emit("onSubmit", {
            data: data
          });
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          if (!result) {
            this.error_show = true; // validate the form if fail
          }
        }
      });
      // return false;
    }
  },
  created() {
    this.field.currency_id = this.org_details.org_currency;
    if (this.page == "update") {
      document.title = getPageTitle(
        this.list.field.pricing_name + " | " + "Price List"
      );
      this.updateFields();
    } else {
      this.field.per_item_import = this.details.pdt_count > 1000 ? true : false;
    }
  },
  computed: {
    filtereditemList() {
      return this.items.filter(item => {
        if (
          (item.pdt_name &&
            item.pdt_name
              .toLowerCase()
              .includes(this.searchitems.toLowerCase())) ||
          (item.pdt_sku &&
            item.pdt_sku.toLowerCase().includes(this.searchitems.toLowerCase()))
        ) {
          return item;
        }
      });
    },
    // to get the required data from the vuex state
    ...mapState({
      list: state => state.pricinglist.list,
      details: state => state.pricinglist.details,
      message: state => state.pricinglist.message,
      updated_id: state => state.pricinglist.updated_id
    }),
    ...mapGetters(["org_details", "orgCurrency", "orgCurrencySymbol"])
  }
};
</script>
<style scoped>
.slab-cols {
  position: relative;
}
.slab-trash {
  position: absolute;
  top: 9px;
  right: 4px;
}
.pricing-table-head {
  border: none !important;
}
.pricing-table .abc-checkbox.index-checkbox {
  width: unset !important;
}
.pricing-table .abc-checkbox input[type="checkbox"] {
  margin-left: 7px !important;
}
.pricing-table .abc-checkbox label {
  padding-left: 0px !important;
}
.pricing-table .abc-checkbox label::after {
  padding-left: 1px !important;
}
</style>
